import React, { Component } from "react";
import { connect } from "redux-bundler-react";

class BasemapLayers extends Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps() {
    // TEST ONLY: swap to "basemapOSM" to render the map locally without a
    // Mapbox token.
    // if (!this.basemapLayer) this.changeBasemap("basemapOSM");
    if (!this.basemapLayer) this.changeBasemap("basemapGray");
  }

  onBasemapChange = (e) => {
    this.changeBasemap(e.target.id);
  };

  changeBasemap = (basemap) => {
    let map = this.props.map;
    let accessToken = `${process.env.REACT_APP_MAPBOX_TOKEN}`;
    if (map) {
      let url = "";
      let attribution = "";
      switch (basemap) {
        // TEST ONLY: keyless basemap for local development (also re-enable the
        // radio button below and the componentWillReceiveProps default).
        // case "basemapOSM":
        //   url = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
        //   attribution = "&copy; OpenStreetMap contributors";
        //   break;
        case "basemapStreet":
          url = `https://api.mapbox.com/styles/v1/usace/cm939k4g0007v01qu4q5x0yew/tiles/256/{z}/{x}/{y}?access_token=${accessToken}`;
          break;
        // --- CARTO basemaps (disabled; replaced by Mapbox entries below) ---
        // case "basemapGray":
        //   url =
        //     "https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png";
        //   break;
        // case "basemapDark":
        //   url =
        //     "https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png";
        //   break;
        case "basemapGray":
          url = `https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/256/{z}/{x}/{y}?access_token=${accessToken}`;
          break;
        case "basemapDark":
          url = `https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/256/{z}/{x}/{y}?access_token=${accessToken}`;
          break;
        default:
          url = `https://api.mapbox.com/styles/v1/usace/cm939otin006r01qthub96e0f/tiles/256/{z}/{x}/{y}?access_token=${accessToken}`;
      }
      if (this.basemapLayer) map.removeLayer(this.basemapLayer);

      // eslint-disable-next-line
      const altPrefix = `<span title="Copyright (c) 2010-2024, Volodymyr Agafonkin\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Copyright (c) 2010-2011, CloudMade\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; All rights reserved."<a href="#">Powered by <u>Leaflet</u></a></span>`;
      this.basemapLayer = window.L.tileLayer(url, { attribution: attribution });
      map.attributionControl.setPrefix(altPrefix);
      map.addLayer(this.basemapLayer);
    }
  };

  render() {
    return (
      <div className="BasemapLayers">
        <div className="legendTitle">Basemaps</div>
        {/* TEST ONLY: keyless OpenStreetMap option. Delete this block (and the
            "basemapOSM" case above) before production. */}
        {/*<div className="basemap">
          <div className="basemapItem">
            <input
              id="basemapOSM"
              onChange={this.onBasemapChange}
              type="radio"
              defaultChecked={true}
              name="optBasemap"
            />
            OpenStreetMap
          </div>
        </div> */}
        <div className="basemap">
          <div className="basemapItem">
            <input
              id="basemapAerial"
              onChange={this.onBasemapChange}
              type="radio"
              name="optBasemap"
            />
            Aerial
          </div>
        </div>
        <div className="basemap">
          <div className="basemapItem">
            <input
              id="basemapStreet"
              onChange={this.onBasemapChange}
              type="radio"
              name="optBasemap"
            />
            Street
          </div>
        </div>
        <div className="basemap">
          <div className="basemapItem">
            <input
              id="basemapGray"
              onChange={this.onBasemapChange}
              type="radio"
              name="optBasemap"
            />
            Light Gray
          </div>
        </div>
        <div className="basemap">
          <div className="basemapItem">
            <input
              id="basemapDark"
              onChange={this.onBasemapChange}
              type="radio"
              name="optBasemap"
            />
            Dark Gray
          </div>
        </div>
      </div>
    );
  }
}

export default connect("selectMap", BasemapLayers);
